import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import TextField from 'material-ui/TextField';
import Dialog, {
  DialogContent,
  DialogTitle
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import Slide from 'material-ui/transitions/Slide';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export default class ETHAddressField extends Component {

  state = {
    modal: false,
    address: ""
  }

  setAddress(address) {
    if (address) {
      if (address.startsWith("ethereum:")) {
        address = address.substring("ethereum:".length);
      }
      this.setState({
        address,
        modal: false
      });
      if (this.props.onAddress) this.props.onAddress(address);
    }
  }

  render() {
    const { label, helper } = this.props;
    const { address, modal } = this.state;

    return (
      <div>

      <TextField
        style={{width:'100%'}}
        label={label || "Ethereum address"}
        value={address || ""}
        onChange={(event)=>this.setAddress(event.target.value)}
        helperText={helper}
      />

      <Button onClick = {() => this.setState({modal:true})}>Scan</Button>

      <Dialog open={modal} transition={Transition}>
        <DialogTitle>Ethereum Address</DialogTitle>
        <DialogContent>
          <QrReader onScan={address=>this.setAddress(address)} onError={e => console.error(e)}/>
        </DialogContent>
      </Dialog>
      </div>

    )
  }
}


// WEBPACK FOOTER //
// ./src/ETHAddressField.js